export const MODAL_THANKS_HTML = `
<div class="fundo-ambiental-thanks">
<img
  onclick="document.querySelector('.fundo-ambiental-modal__overlay').style.display = 'none'"
  class="fundo-ambiental-modal__close"
  src="https://t.womtp.com/slider/c/Iberdrola/pt/main/create-satellite/modals/img/close.svg"
  alt="botão fechar"
/>
<img
  src="https://t.womtp.com/slider/c/Iberdrola/pt/main/create-satellite/modals/img/check.svg"
  alt="ícone de verificação"
/>
<p>Obrigado pelo contacto</p>
</div>
`
//prueba